import { Tooltip } from "@mui/material";
import { Icons } from "assets";
import classNames from "classnames";
import { useState } from "react";
import MultiAxisLineChart from "shared/components/lineGraph";
import RangeDatePicker from "shared/components/rangeDatePicker";
import styles from "./style.module.scss";

function TransactionGraph({
  label,
  isFullScreenRequired,
  openFullScreen,
  setOpenFullScreen,
}: any) {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(new Date());


  let dataSetsForGraphs = [
    {
      label: "Monthly Plan",
      data: [
        "10",
        "15",
        "20",
        "25",
        "30",
        "35",
        "40",
        "45",
        "50",
        "55",
        "60",
        "100",
        "200",
        "300",
        "400",
        "500",
        "600",
        "700",
        "800",
        "900",
        "750",
        "650",
        "550",
        "450",
        "350",
        "250",
        "150",
        "50",
      ],
      borderColor: "#9A469B",
      backgroundColor: "#9A469B",
      pointRadius: 5,
      pointHoverRadius: 7,
      pointBorderColor: "rgba(0, 0, 0, 0)",
      pointBackgroundColor: "rgba(0, 0, 0, 0)",
      pointHoverBackgroundColor: "#9A469B",
      pointHoverBorderColor: "#FFFFFF",
    },
    {
      label: "Annual Plan",
      data: [
        "5",
        "10",
        "15",
        "20",
        "30",
        "40",
        "50",
        "60",
        "70",
        "80",
        "100",
        "780",
        "300",
        "800",
        "500",
        "600",
        "400",
        "800",
        "450",
        "950",
        "800",
        "700",
        "600",
        "500",
        "400",
        "300",
        "200",
        "100",
      ],
      borderColor: "#EF437B",
      backgroundColor: "#EF437B",
      pointRadius: 5,
      pointHoverRadius: 7,
      pointBorderColor: "rgba(0, 0, 0, 0)",
      pointBackgroundColor: "rgba(0, 0, 0, 0)",
      pointHoverBackgroundColor: "#EF437B",
      pointHoverBorderColor: "#FFFFFF",
    },
  ];

  return (
    <div className={styles.graphMainContainer}>
      <div className={styles.headingContainer}>
        <div className={styles.analyticsHeading}>
          Transaction Analytics {label ? " of " + label : ""}
        </div>

        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
          <RangeDatePicker
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            labelStyle={styles.dateLabel}
          />
          <div>
            {isFullScreenRequired && (
              <div className={styles.filterContainer}>
                <Tooltip
                  componentsProps={{
                    tooltip: { className: "tooltip" },
                    arrow: { className: "arrow" },
                  }}
                  placement="top"
                  arrow
                  title="Full Screen"
                >
                  <button
                    className={classNames(styles.btn, styles.fullScreenBtn)}
                    onClick={() => {
                      setOpenFullScreen(true);
                    }}
                  >
                    <Icons.FullScreenIcon />
                  </button>
                </Tooltip>
                <Tooltip
                  componentsProps={{
                    tooltip: { className: "tooltip" },
                    arrow: { className: "arrow" },
                  }}
                  placement="top"
                  arrow
                  title="Minimized"
                >
                  <button
                    className={classNames(styles.btn, styles.minimizeBtn)}
                  >
                    <Icons.MinimizeIcon2 />
                  </button>
                </Tooltip>
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        className={
          !isFullScreenRequired ? styles.graphFullContainer : styles.graphContainer
        }
      >
        <MultiAxisLineChart
          datasets={dataSetsForGraphs}
          legend={false}
          canvasStyle={!isFullScreenRequired && styles.canvas}
          responsive={true}
          labels={[
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
          ]}
        />
      </div>
    </div>
  );
}

export default TransactionGraph;
